const Question = ({ question, choices, onAnswer, onNextQuestion, correctAnswer, userAnswer, clicked, nextButtonLabel }) => {
  const choicesObj = choices.map((choice, index) => ({ id: index, choice }));

  return (
    <>
      <div className="title is-size-5 has-text-centered pb-4">{question}</div>
      <div className="is-flex is-flex-direction-column">
        {choicesObj.map(({ id, choice }) => (
          <div className="mb-4" key={id}>
            <button
              type="button"
              className={`button is-fullwidth is-large
            ${clicked && choice === correctAnswer && userAnswer !== choice ? 'is-danger' : clicked && choice === correctAnswer && userAnswer === choice ? 'is-success' : ''}`}
              style={{
                height: 'auto',
                border: userAnswer === choice ? '3px solid #333' : ''
              }}
              onClick={() => onAnswer(choice)}
              disabled={clicked}
            >
              <p
                style={{
                  whiteSpace: 'break-spaces'
                }}
              >
                {choice}
              </p>
            </button>
          </div>
        ))}
      </div>

      <div>
        <button type="button" className="button p-5 is-large is-fullwidth is-warning" onClick={onNextQuestion} disabled={!clicked}>
          {nextButtonLabel}
        </button>
      </div>
    </>
  );
};

export default Question;
